import { render, staticRenderFns } from "./training-tool-attach-file.vue?vue&type=template&id=6375522d&"
import script from "./training-tool-attach-file.vue?vue&type=script&lang=js&"
export * from "./training-tool-attach-file.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports